import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.3.0_@parcel+watcher@2.5.6_@types+node@25.2.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_0eb130ae073bbae7b7ba124eb928cdb6/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/packages/website-builder/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}